import { useSelector } from "react-redux";

import { RootState } from "../redux/store";
import { selectPermissions } from "../redux/userSlice";

export default function useAuthorization(requiredPermissions: string[], isInclusive = true): boolean {
	const permissions = useSelector((state: RootState) => selectPermissions(state));
	if (requiredPermissions && permissions) {

		if (!permissions.includes("ACCESS_MP")) return false;

		if (isInclusive) {
			return requiredPermissions.every(permission => permissions.includes(permission));
		} else {
			if (permissions.includes("ACCESS_MP")) {
				const tempPermissions = [...permissions].filter(permission => permission !== "ACCESS_MP");
				return requiredPermissions.some(permission => tempPermissions.includes(permission));
			} else {
				return false;
			}
		}
	} else {
		return false;
	}
}
